<template>
 <div>
  <div class="vx-row mx-2">
   <div class="router-header flex flex-wrap items-center mb-6">
    <div
     class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
    >
     <h2 class="mb-1">ข้อมูลผู้ใช้งาน</h2>
    </div>
    <p class="mx-5 mt-2">รายละเอียดข้อมูลผู้ใช้งาน</p>
   </div>
  </div>
  <vx-card class="p-5">
   <div class="vx-row">
    <div class="vx-col md:w-1/3 w-full mt-5"></div>
    <vs-divider position="center">ข้อมูลส่วนตัว</vs-divider>
    <div class="vx-col md:w-1/3 w-full mt-5">
     <div class="vx-row">
      <div class="vx-col md:w-1/2">
       <h6 align="right">คำนำหน้า :</h6>
      </div>
      <div class="vx-col md:w-1/2">
       <p>{{ detailInfo.title }}</p>
      </div>
     </div>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
     <div class="vx-row">
      <div class="vx-col md:w-1/2">
       <h6 align="right">ชื่อ :</h6>
      </div>
      <div class="vx-col md:w-1/2">
       <p>{{ detailInfo.firstName }}</p>
      </div>
     </div>
    </div>
    <div class="vx-col md:w-1/4 w-full mt-5">
     <div class="vx-row">
      <div class="vx-col md:w-1/2">
       <h6 align="right">นามสกุล :</h6>
      </div>
      <div class="vx-col md:w-1/2">
       <p>{{ detailInfo.lastName }}</p>
      </div>
     </div>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
     <div class="vx-row">
      <div class="vx-col md:w-1/2">
       <h6 align="right">ตำแหน่ง :</h6>
      </div>
      <div class="vx-col md:w-1/2">
       <p>{{ detailInfo.position }}</p>
      </div>
     </div>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
     <div class="vx-row">
      <div class="vx-col md:w-1/2">
       <h6 align="right">เบอร์โทร :</h6>
      </div>
      <div class="vx-col md:w-1/2">
       <p>{{ detailInfo.phoneNumber }}</p>
      </div>
     </div>
    </div>
    <div class="vx-col md:w-1/4 w-full mt-5">
     <div class="vx-row">
      <div class="vx-col md:w-1/2">
       <h6 align="right">อีเมล :</h6>
      </div>
      <div class="vx-col md:w-1/2">
       <p>{{ detailInfo.email }}</p>
      </div>
     </div>
    </div>
    <div class="vx-col md:w-1/3 w-full mt-5">
     <div class="vx-row">
      <div class="vx-col md:w-1/2">
       <h6 align="right">เขต :</h6>
      </div>
      <div class="vx-col md:w-1/2">
       <p>{{ detailInfo.zone.name }}</p>
      </div>
     </div>
    </div>
    <vs-divider position="center"></vs-divider>
   </div>
   <div align="right" class="mt-10">
    <vs-button
     class="mr-5"
     color="primary"
     type="filled"
     v-show="isSuperVisorOrObserb"
     @click="gotoEdit()"
     >แก้ไขโปรไฟล์</vs-button
    >
   </div>
  </vx-card>
 </div>
</template>

<script>
// import { ENDPOINT } from '../../../constants/endpoint'

export default {
 props: {},
 data() {
  return {
   detailInfo: {
    id: null,
    title: null,
    firstName: null,
    lastName: null,
    position: null,
    phoneNumber: null,
    email: null,
    zone: null,
   },
   userDetail: [],
   imageCitizenUrl: null,
   isSuperVisorOrObserb: true,
  }
 },
 mounted() {
  this.init()
  // this.checkRole()
 },
 methods: {
  // checkRole() {
  //  const currentRole = localStorage.getItem('userRole')
  //  if (currentRole != 'ROLE_ADMIN') {
  //   this.isSuperVisorOrObserb = false
  //  } else {
  //   this.isSuperVisorOrObserb = true
  //  }
  // },
  gotoEdit() {
   this.$router.push(`/settings/profile-edit/${this.detailInfo.id}`)
  },
  async init() {
   await this.$store.dispatch('users/setUserById', {
    id: this.$route.params.id,
   })
   this.userDetail = this.$store.state.users.user
   console.log('this is user detail :', this.userDetail)
   this.detailInfo = {
    id: this.userDetail.id,
    title: this.userDetail.title,
    firstName: this.userDetail.firstName,
    lastName: this.userDetail.lastName,
    position: this.userDetail.position,
    phoneNumber: this.userDetail.phoneNumber,
    email: this.userDetail.email,
    zone: this.userDetail.zone,
   }
  },
  watch: {
   userDetail: (val, old) => {
    console.log('data :', val, old)
   },
  },
 },
}
</script>

<style lang="scss" scoped></style>
